import React, { useState } from "react";
import Button from "@mui/material/Button";
import { makeStyles } from "@material-ui/styles";
import { intialBranch } from ".";
import PermissionCheck from "../../../Component/PermissionCheck";

const useStyles = makeStyles({
  menu: {
    "& .MuiPaper-elevation": {
      borderRadius: "10px",
    },
  },
});
function DashTabs({ setshow, show, setBranchDetail }) {
  const [activeId, setActiveId] = useState<any>(1);
  const values = [
    { id: 1, text: "All" },
    { id: 2, text: "IVF Clinics" },
    { id: 3, text: "Converted" },
    { id: 4, text: "General Hospital" },
    { id: 5, text: "Hospital type 3" },
    { id: 6, text: "Hospital type 4" },
  ];
  return (
    <div className="Dash-table mt-4">
      <ul>
        {values.map((val, i) => (
          <li onClick={() => setActiveId(val.id)} key={i}></li>
        ))}
      </ul>
      {PermissionCheck("hospital_branch", "add") && (
        <div style={{ float: "right" }}>
          <Button
            variant="contained"
            id="btn"
            onClick={() => {
              setshow(!show);
              setBranchDetail(intialBranch);
            }}
          >
            + Add branch
          </Button>
        </div>
      )}
    </div>
  );
}

export default React.memo(DashTabs);
